import React from "react"
import styled from "styled-components"

const StyledInput = styled.input`
  opacity: 0.75;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.055em;
  background-image: url(${props =>
    props.search
      ? "data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='30' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>"
      : null});
  background-repeat: no-repeat;
  background-position: right center;
  border: none;
  height: 35px;
  width: 100%;

  &:focus {
    color: rgba(4, 6, 44, 1);
    opacity: 1;
    outline: none;
  }
`

const Border = styled.div`
  border-bottom: 1px solid #000;
  width: 100%;
`
const InputIcon = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.9);
  opacity: 0.75;
  padding-right: 5px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.055em;
  border: none;
  height: 35px;
  width: 100%;
  margin: ${props => props.margin};
  &:focus-within {
    color: rgba(4, 6, 44, 1);
    opacity: 1;
    outline: none;
  }
  span {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 50%;
    &:after {
      content: "";
      display: block;
      height: 80%;
      width: 1px;
      top: 0;
      left: 0;
      position: absolute;
      transform: translateY(10%);
      background: rgba(4, 6, 44, 0.3);
    }
  }
  input {
    background: none;
    border: none;
    height: 100%;
    &:focus-visible,
    &:focus {
      outline: none;
    }
  }
`

const Input = ({ field, icon, ...props }) => {
  delete props.form

  if (props.type === "hidden") {
    return <input {...field} {...props} data-cy={field?.name || props?.name} />
  }

  if (icon) {
    return (
      <Border>
        <InputIcon>
          <input {...field} {...props} data-cy={field?.name || props?.name} />
          <span>{icon}</span>
        </InputIcon>
      </Border>
    )
  } else {
    return (
      <Border>
        <StyledInput
          {...field}
          {...props}
          data-cy={field?.name || props?.name}
        />
      </Border>
    )
  }
}

export { Input }
